
import {
  IonGrid,
  IonRow,
  IonCol,
  IonInput
} from '@ionic/vue';
import { defineComponent, onMounted, PropType, ref, Ref, toRef } from "vue";
import axiosInstance from "@/axiosInstance";
import frTranslations from '@/locales/fr.json';
import AutoFillSelect from '@/components/AutoFillSelect.vue';
import { PhotovoltaicData } from '@/types/PhotovoltaicData';

export default defineComponent({
  name: "PhotovoltaicDataForm",
  components: {
    IonGrid,
    IonRow,
    IonCol,
    IonInput,
    AutoFillSelect
  },
  props: {
    companyId: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  setup(props) {
    const currentLanguage = ref('fr');
    const translations = {
      fr: frTranslations,
    };
    const dataLoaded = ref(false);
    const companyId = toRef(props, 'companyId');
    const data = ref<PhotovoltaicData>({});
    const types = ref([]);
    const selectedType = ref<any>({});
    const supportTypes = ref([]);
    const selectedSupportType = ref<any>({});

    const submitForm = async () => {
      try {
        data.value = await updateData(companyId, data.value);
        dataLoaded.value = true;
      } catch (error) {
        console.error('Error updating production data:', error);
      }
    };

    const getTypes = async () => {
      try {
        const response = await axiosInstance.get(`api/core/photovoltaic-types/`);
        return response.data;
      } catch (error) {
        console.error(error);
        return "";
      }
    };

    const getSupportTypes = async () => {
      try {
        const response = await axiosInstance.get(`api/core/photovoltaic-support-types/`);
        return response.data;
      } catch (error) {
        console.error(error);
        return "";
      }
    };

    onMounted(async () => {
      data.value = await getData(companyId);
      types.value = await getTypes();
      supportTypes.value = await getSupportTypes();
      
      dataLoaded.value = true;
    });

    const getData = async (companyId: Ref<number>) => {
      try {
        const response = await axiosInstance.get(`api/core/photovoltaic-data/${companyId.value}/`);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    };

    const updateData = async (companyId: Ref<number>, data: any) => {
      try {
        const response = await axiosInstance.put(`api/core/photovoltaic-data/${companyId.value}/update/`, data);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    };

    const handleSelected = (option: any, item: any, field: string, update = false) => {
      item[field] = option ? option.id : null;
      if (field == 'type') {
        selectedType.value = option;
      }
      if (field == 'support_type') {
        selectedSupportType.value = option;
      }
      if (update) {
        updateData(companyId, item);
      }
    }

    return {
      translations,
      currentLanguage,
      data,
      types,
      selectedType,
      supportTypes,
      selectedSupportType,
      submitForm,
      handleSelected,
    };
  },
});
